export default "__VITE_PUBLIC_ASSET__f79072fc__"